module.exports = __webpack_public_path__ + "img/content4.963d1ab2.png";